module.exports = __webpack_public_path__ + "/images/ico-nav-question.09e8dbe.svg";